import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
export function LimitedOffer() {
  const getInitialTime = () => {
    const minutes = Math.floor(Math.random() * 7) + 8;
    const seconds = Math.floor(Math.random() * 60);
    return minutes * 60 + seconds;
  };
  const [timeLeft, setTimeLeft] = useState(getInitialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return getInitialTime();
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-4 md:py-8 px-4 bg-transparent" data-id="element-204">
      <div className="max-w-2xl mx-auto" data-id="element-205">
        <FadeIn data-id="element-206">
          <div className="bg-slate-900 rounded-2xl py-5 md:py-8 px-5 md:px-10 text-center shadow-[0_0_30px_rgba(239,68,68,0.15)] border border-slate-800" data-id="element-207">
            <h3 className="text-kid-yellow font-medium text-xs md:text-base uppercase tracking-widest mb-1.5 md:mb-2 flex items-center justify-center gap-2" data-id="element-208">
              <span data-id="element-209">🔥</span>
              <span data-id="element-210">OFERTA SOLO POR HOY</span>
            </h3>

            <p className="text-slate-400 text-[11px] md:text-sm mb-4 md:mb-6 max-w-md mx-auto" data-id="element-211">
              Reserva válida por 15 minutos. Si no accedés, tu descuento pasa a
              la siguiente persona.
            </p>

            <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-212">
              <div className="bg-slate-800 rounded-lg px-4 py-2.5 md:px-6 md:py-4 min-w-[65px] md:min-w-[90px] border border-slate-700" data-id="element-213">
                <div className="text-white font-heading text-2xl md:text-4xl font-bold tracking-tight" data-id="element-214">
                  {formatNumber(minutes)}
                </div>
                <div className="text-slate-500 text-[9px] md:text-xs uppercase tracking-wider mt-0.5 md:mt-1 font-medium" data-id="element-215">
                  MIN
                </div>
              </div>

              <div className="text-slate-600 text-lg md:text-2xl font-medium" data-id="element-216">
                :
              </div>

              <div className="bg-slate-800 rounded-lg px-4 py-2.5 md:px-6 md:py-4 min-w-[65px] md:min-w-[90px] border border-slate-700" data-id="element-217">
                <div className="text-white font-heading text-2xl md:text-4xl font-bold tracking-tight" data-id="element-218">
                  {formatNumber(seconds)}
                </div>
                <div className="text-slate-500 text-[9px] md:text-xs uppercase tracking-wider mt-0.5 md:mt-1 font-medium" data-id="element-219">
                  SEG
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}